// Pure, React-free entry point (`@moment/app-config-ui/permissions`). Keeps the
// permission enums/data out of the main barrel's client-context graph, so
// server modules can import `Permission` etc. without pulling in `createContext`.
export type { PermissionCheck } from './schema'
export type {
  PermissionMode,
  SelfPermissionsResult,
  UseHasPermissions,
} from './use-has-permissions'

export { EducationPermissions } from './education-permissions'
export { CheckOnlyPermission, Permission } from './schema'
export { hasPermission } from './scope'
export { TradingPermissions } from './trading-permissions'
export { createUseHasPermissions } from './use-has-permissions'
